import { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Galerie() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lightbox, setLightbox] = useState(null);

  useEffect(() => {
    api
      .get("/gallery")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-20" data-testid="galerie-page">
      <p className="text-xs tracking-[0.3em] uppercase text-[#FF6B1A] mb-4">Galerie</p>
      <h1 className="font-display text-5xl sm:text-7xl leading-none mb-4">LE SHOW EN IMAGES</h1>
      <p className="text-white/60 max-w-2xl mb-12 text-lg">
        Les meilleurs moments du tournoi, capturés sur le bitume.
      </p>

      {loading ? (
        <p className="text-white/50">Chargement…</p>
      ) : items.length === 0 ? (
        <div className="uf-card p-12 text-center">
          <p className="font-display text-2xl text-white/60">Bientôt en ligne</p>
          <p className="text-white/40 mt-2">Les photos seront publiées pendant et après l'événement.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3" data-testid="gallery-grid">
          {items.map((it) => (
            <button
              key={it.id}
              onClick={() => setLightbox(it)}
              className="group relative aspect-square overflow-hidden uf-card p-0 hover:border-[#FF6B1A] transition-colors"
              data-testid={`gallery-item-${it.id}`}
            >
              <img
                src={it.image_base64}
                alt={it.title || "Urban Fest"}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {it.title && (
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/90 to-transparent p-3">
                  <p className="text-xs uppercase tracking-widest font-bold">{it.title}</p>
                </div>
              )}
            </button>
          ))}
        </div>
      )}

      {lightbox && (
        <div
          onClick={() => setLightbox(null)}
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4 cursor-zoom-out"
          data-testid="gallery-lightbox"
        >
          <img
            src={lightbox.image_base64}
            alt={lightbox.title || ""}
            className="max-w-full max-h-[90vh] object-contain"
          />
        </div>
      )}
    </div>
  );
}
